// state
export const state = {
  // Dashboard modules will observe this data and eventually refresh their data
  moduleKey: +(new Date()),
};

// getters
export const getters = {
  // Dashboard modules will observe this data and eventually refresh their data
  getModuleKey: (state) => state.moduleKey,
};

// mutations
export const mutations = {
  /**
   * Use this mutation to refresh the "module key"
   * @param state
   */
  commitModuleKey(state) {
    state.moduleKey = +(new Date());
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
